export default "__VITE_ASSET__Ckl1Lnp4__"